import { CSSProperties } from "react";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import { APICONSTANT } from "../../../utils/api/Config";

const spinnerStyle: CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 auto",
};

const fullPageOverlay: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.85)",
  zIndex: 9999,
};

function DynamicLoader({ loading = true }: any) {
  const selectorData = useSelector((state) => state?.dynamicData ?? {});
  const isLoginLoading = Boolean(selectorData?.loaders?.[APICONSTANT.login]);
  const isLoggingOut = selectorData.loaders[APICONSTANT.loginOut];

  // Determine the mode
  const isFullPage = isLoginLoading || isLoggingOut;

  if (!loading) return null;

  return (
    <div
      style={isFullPage ? fullPageOverlay : undefined}
      className="sweet-loading"
    >
      <div className="flex flex-col items-center justify-center gap-3">
        <ClipLoader
          color={"#3B82F6"}
          loading={loading}
          cssOverride={spinnerStyle}
          size={40}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        <p className="text-gray-500 text-sm font-medium animate-pulse">
          Loading ...
        </p>
      </div>
      {isFullPage && (
        <p className="text-gray-700 text-lg font-medium mt-4 animate-pulse">
          Please wait ...
        </p>
      )}
    </div>
  );
}

export default DynamicLoader;
